<script setup lang="ts">

import ExtensionLogo from "@/extension/components/extension-logo/ExtensionLogo.vue";
import ExpandableTextOverflow from "@/core/components/expandable-text-overflow/ExpandableTextOverflow.vue";
import MarkdownView from "@/core/components/markdown/Markdown.vue";
import ExtensionSlider from "@/extension/components/extension-slider/ExtensionSlider.vue";
import {computed} from "vue";
import {useExtensionStore} from "@/stores/extension.store";

const extensionStore = useExtensionStore();

const extension = computed(() => {
    return extensionStore.extensionBySlug('asafo');
});
</script>

<template>
  <div v-if="extension">
    <div class="flex bg-white p-6 gap-3">
      <ExtensionLogo :extension="extension" />
      <div class="self-end flex-1">
        <h1>{{ extension.name }}</h1>
        <p>{{ extension.short_description }}</p>
        <p v-if="extension.latest_active_trial && extension.trial_vouchers?.length" class="text-sm">
          {{ extension.trial_vouchers[0].description }}
        </p>
      </div>
    </div>
    <div class="p-6 bg-lightPurple-lightest flex flex-row space-between">
      <expandable-text-overflow class="basis-full">
        <MarkdownView :content="extension.description" />
      </expandable-text-overflow>
      <div v-if="extension.video_url || extension.previews?.length" class="w-64 pl-4">
        <extension-slider :extension="extension" class="w-24" />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
